<template>
	<div>
		<SubNav v-bind:active="2"></SubNav>
		<div class="profile-img">
			<img :src="imgUrl" alt="">
		</div>
		<div class="profile-content">
			<ul>
				<li class="news" v-for="item in newsList">
					<div class="pic">
						<img width="220" height="140" :src="item.thumbnail">
					</div>
					<div class="text">
						<h2>{{item.title}}</h2>
						<span>{{item.createtime}}</span>
						<p>{{item.summary}}</p>

                        <router-link v-if="item.url == ''" :to="{ name:'news-details', query: { news_id: item.id }}">
                            <span style="color: #EE1234">查看详情</span>
                        </router-link>
                        <a v-else :href="item.url" target="_blank">
                            <span style="color: #EE1234">查看详情</span>
                        </a>

					</div>
					<div class="icon">
						<i class="fa fa-flag fa-4x" aria-hidden="true"></i>
					</div>
				</li>
			</ul>

			<div class="page">
				<Page :total="total" :current="page_count" @on-change="changePage"  prev-text="上一页" next-text="下一页" />
			</div>
		</div>
	</div>
</template>

<script>
    import SubNav from './SubNav.vue'
	import * as profile from '@/controller/profile'

	export default {
		name: "news",
        components: {
            SubNav
        },
		data() {
			return {
				newsList: [],
				imgUrl: '',
				total: 0,
				page_count: 1
			}
		},
		mounted() {
			this.showBanner()
			this.showNews()
		},
		methods: {
			//显示banner图
			showBanner() {
				profile.fetchBanner()
					.then(result => {
						this.imgUrl = result.imgUrl.news
					})
			},
			//显示新闻列表
			showNews() {
				profile.fetchNews(this.page_count)
					.then(result => {
						this.newsList = result.list.list
						this.total = result.list.item_count
					})
			},
			// 点击分页触发
			changePage(val) {
				this.page_count = val
				this.showNews(this.page_count)
			}
		}
	}
</script>

<style scoped lang="stylus">
$width = 1000px
a
    color #95989D
.profile-img
    background-color white
    overflow hidden
    img
        width 100%
.profile-content
    width $width
    margin 0 auto
    a:hover
        color #EE1234
    ul
        list-style none
        margin-top 30px
        .news
            display block
            padding 20px 10px
            height 180px
            background-color #F9F9F9
            border-bottom 1px solid #E7E7E7
            &:hover
                background-color #E1E1E1
            .pic
                display block
                float left
                width 220px
                height 140px
                margin-right 10px
            .text
                display block
                width 600px
                float left
                overflow hidden
                text-align left
                h2
                    margin-bottom: 10px
                    color #060606
                p
                    color #95989D
                    overflow: hidden
                span
                    color #95989D
            .icon
                padding-top 50px
                margin 0 30px
                color #E6E6E6
.page
    text-align center
    margin-bottom 30px
</style>